// 1000 => 1k
export const formatNumberAsKilo = (
  value: number,
  decimalPlaces = 1,
): string => {
  if (value < 1000) {
    return value.toString();
  }

  const suffixes = ['', 'k', 'M'];
  let suffixIndex = 0;
  let newValue = value;

  while (newValue >= 1000 && suffixIndex < suffixes.length - 1) {
    newValue /= 1000;
    suffixIndex++;
  }

  // 小数点以下の桁数を指定してフォーマット
  const factor = 10 ** decimalPlaces;
  const formattedValue = Math.floor(newValue * factor) / factor;

  // 不要な小数点以下のゼロを削除
  const trimmedValue = Number.parseFloat(formattedValue.toString()).toFixed(
    decimalPlaces,
  );

  return `${trimmedValue}${suffixes[suffixIndex]}`;
};
